import PortfoliosLibrary from './PortfoliosLibrary';

export default PortfoliosLibrary;
